import { TextLongLeftIcon } from '@zep-us/zus/icons';
import { Blue500, Green600, Pink400, Purple400 } from '@zep-us/zus/tokens';
import { CheckSmallCircleFillIcon, MessageLinesFillIcon } from '@/icons';
import { LocalizedOxTypeIcon } from '@/shared/components/LocalizedOxTypeIcon';
import { type QuizType } from '../../type';
export const QUIZ_TYPE_ICON_MAP: Record<QuizType, React.JSX.Element> = {
  multiple: <CheckSmallCircleFillIcon size="xs" fill={Green600} />,
  subjective: <MessageLinesFillIcon size="xs" fill={Blue500} />,
  ox: <LocalizedOxTypeIcon size="xs" fill={Purple400} />,
  essay: <TextLongLeftIcon size="xs" fill={Pink400} />
};